var lazyloadImages;
var debounce = require("../debounce");

function init(){
  lazyloadImages = document.querySelectorAll(".lazy");
  var intersectionObserverSupport = "IntersectionObserver" in window;
  if(Array.from(lazyloadImages).length > 0) {
    if (intersectionObserverSupport) {
      var imageObserver = new IntersectionObserver(function (entries, observer) {
        Array.from(entries).forEach(function (entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            image.classList.remove("lazy");
            imageObserver.unobserve(image);
          } else {
            if (entry.isIntersecting === undefined) {
              // somehow UC Browser returns "entry.isIntersecting" as undefined, even though it has "intersectionObserverSupport" as true.
              removeLazy(Array.from(lazyloadImages))
            }
          }
        });
      },{rootMargin: '0px 0px 100px 0px'});

      Array.from(lazyloadImages).forEach(function (image) {
        imageObserver.observe(image);
      });
    } else {
      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
    //if browser does not support IntersectionObserver
    if (!intersectionObserverSupport) {
      removeLazy(Array.from(lazyloadImages))
    }
  }
}

function removeLazy(imagesWithLazyClass){
  //browser does not support IntersectionObserver, so remove lazy class
  if(imagesWithLazyClass.length > 0) {
    for(var i = 0; i < imagesWithLazyClass.length; i++){
      imagesWithLazyClass[i].classList.remove('lazy');
    }
  }
}

function lazyload () {
  debounce(function () {
    var scrollTop = window.pageYOffset;
    if(lazyloadImages.length > 0) {
      Array.from(lazyloadImages).forEach(function (img) {
        if (img.offsetTop < (window.innerHeight + scrollTop)) {
          img.src = img.dataset.src;
          img.classList.remove('lazy');
        }
      });
    }
    if(lazyloadImages.length == 0) {
      document.removeEventListener("scroll", lazyload);
      window.removeEventListener("resize", lazyload);
      window.removeEventListener("orientationChange", lazyload);
    }
  }, 20)
}


document.addEventListener("DOMContentLoaded", init)

module.exports.checkLazy = init;